module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_container",
    attrs: {
      "id": "djs-content-container"
    }
  }, [_c('docendo-connnection-indicator'), _vm._v(" "), _c('router-view', {
    staticClass: "d-sidenav-active",
    attrs: {
      "name": "SideNav"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-width d-page-width",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "Header"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "Navigation"
    }
  }), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('Toast')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-baac5c42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1730
// module chunks = 1